import { useGetCompanies, type Company } from '@entities/company';
import { Loader, Select, type SelectProps } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { PaginateType } from '@shared/types';

export const CompanySelect = ({ ...props }: SelectProps) => {
  const { data, isLoading } = useGetCompanies({
    filter: {},
    paginate: PaginateType.NONE,
  });

  const companies = (Array.isArray(data) ? data : data?.data) as
    | Company[]
    | undefined;

  return (
    <Select
      data={
        companies?.map(item => ({
          label: item.name,
          value: item.id.toString(),
        })) ?? []
      }
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      searchable
      {...props}
    />
  );
};
